'use strict';

angular.module('licensure.services')
    .factory('EXCandidates', ['$http', '$q', function ($http, $q) {
        return {
            getCandidateBySession: function (id) {
                var d = $q.defer();

                $http
                    .get(apiLocation + "/api/ExamModule/ExamSessions/" + id + "/CandidateSummaries", {
                        params: {}
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            }
        }
    }])
    ;